import React, { useEffect, useState } from 'react';
import axios from 'axios';
import apiUrl from '../Api/api';

const Rough = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        // Make a request to the backend with credentials
        axios.get(`${apiUrl}/api/data`, { withCredentials: true })
            .then(response => {
                setData(response.data);  // Handle response data
            })
            .catch(error => {
                console.error('Error fetching data with credentials:', error);
            });
    }, []);

    return (
        <div>
            <h1>With Credentials Example</h1>
            {data ? <p>Data: {data.message}</p> : <p>Loading...</p>}
        </div>
    );
};

export default Rough;
